<button name="btn-delete" class="container-button-delete" mat-icon-button (click)="onClick()" [disabled]="disableButton"
      [matTooltip]="tooltip">
      <span id="btn-delete" class="mb-0 font-size-button" [ngClass]="opacityText ? 'color-gray-omicron':'colo-black'" *ngIf="showHasText">Eliminar</span>
      <img src="assets/icons/trash.svg" alt="favorite" *ngIf="!showHasText && !disableButton">
      <img src="assets/icons/trash_gray.svg" alt="favorite" *ngIf="!showHasText && disableButton">
</button>